export const languages_info = {
  en_US: {
    without_country: "en"
  },
  pt_BR: {
    without_country: "pt"
  },
  pt_PT: {
    without_country: "pt"
  },
  es_ES: {
    without_country: "es"
  },
  fr_FR: {
    without_country: "fr"
  }
};